<app-state-section [state]="sectionState" class="madar--v2">
    <mat-card>
      <app-row class="p-4">
        <app-col><h6>{{'Users.UserParams' | translate}}</h6></app-col>
        <app-col cols="auto">
          <button
            mat-button
            color="primary"
            class="btn--link"
            *grantAccess="RolesConstants.USER_PARAMS_ADD ; onlyIf: !isEditMode"
            (click)="isEditMode = true">
            <mat-icon>add</mat-icon>
            {{'Buttons.Create' |  translate}} / {{'Buttons.Edit' | translate}}
          </button>
        </app-col>
      </app-row>

      <mat-card-content *ngIf="!isEditMode">
        <p *ngIf="!dataSource?.data?.length">{{'Users.NoParams' | translate}}</p>
        <table mat-table *ngIf="dataSource?.data?.length" [dataSource]="dataSource" matSortDirection="asc"  class="table scrollable scrollable--x w-100">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ 'Users.ParamName' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <ng-container matColumnDef="creationTemplate">
            <th mat-header-cell *matHeaderCellDef>{{ 'ShipmentCreationTemplate.CreationTemplate' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.creationTemplate }}</td>
          </ng-container>

          <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef>{{ 'Users.ParamKey' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.key }}</td>
          </ng-container>

          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>{{ 'Users.ParamValue' | translate }}</th>
            <td mat-cell *matCellDef="let element">{{ element.value }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </mat-card-content>

      <mat-card-content *ngIf="isEditMode">
          <div *ngIf="form?.controls as userParams" class="pt-4">
            <app-row *ngFor="let param of userParams; let i = index;" gutter="x-xs">
              <app-col>
                <app-row gutter="x-xs">
                  <app-col md="6" lg="3">
                    <mat-label class="d-block w-100">{{'ShipmentCreationTemplate.CreationTemplate' | translate}}</mat-label>
                    <mat-form-field class="d-block w-100" appearance="outline">
                      <mat-select [formControl]="param.controls.creationTemplate">
                        <ng-container *ngFor="let type of (ShipmentCreationTemplateTypes|enumToArray) || []">
                          <mat-option [value]="type.value">{{('Enum.ShipmentCreationTemplateTypes.' + type.key) | translate}}</mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </app-col>
                  <app-col md="6" lg="3">
                    <mat-label class="d-block w-100">{{'Users.ParamName' | translate}}</mat-label>
                    <mat-form-field class="d-block w-100" appearance="outline">
                      <input matInput type="text" [formControl]="param?.controls?.name">
                    </mat-form-field>
                  </app-col>
                  <app-col md="6" lg="3">
                    <mat-label class="d-block w-100">{{'Users.ParamKey' | translate}}</mat-label>
                    <mat-form-field class="d-block w-100" appearance="outline">
                      <input matInput type="text" [formControl]="param.controls.key">
                    </mat-form-field>
                  </app-col>
                  <app-col md="6" lg="3">
                    <mat-label class="d-block w-100">{{'Users.ParamValue' | translate}}</mat-label>
                    <mat-form-field class="d-block w-100" appearance="outline">
                      <input matInput type="text" [formControl]="param.controls.value">
                    </mat-form-field>
                  </app-col>
                </app-row>
              </app-col>
              <app-col cols="auto" class="pt-6">
                <button type="button" *ngIf="!param.value?.id" mat-icon-button color="warn" (click)="form.removeAt(i)"><mat-icon>delete</mat-icon></button>
              </app-col>
            </app-row>
            <div *ngIf="userParams?.length < 1" class="text-center p-4">{{ 'Users.NoSelectedParams' | translate }}</div>
          </div>
          <button mat-raised-button color="primary" [disabled]="form?.invalid" (click)="addMoreUserParam()" class="mt-3">{{ "Buttons.AddMore" | translate }}</button>
      </mat-card-content>
    </mat-card>

  <app-row *ngIf="isEditMode" class="mt-6">
    <app-col cols="6" md="4" lg="3" class="mr-auto">
      <button mat-button (click)="isEditMode = false; initForm();" class="btn-secondary d-block w-100">{{'Buttons.Cancel' | translate}}</button>
    </app-col>
    <app-col cols="6" md="4" lg="3">
      <button
          class="d-block w-100"
          mat-raised-button
          (click)="save()"
          color="primary">
        {{'Buttons.Save' | translate}}
      </button>
    </app-col>
  </app-row>
</app-state-section>
